var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.213,
    height: 42.213,
    viewBox: "0 0 42.213 42.213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M58.121,35.111a8,8,0,0,0,.07-1.048,8.09,8.09,0,0,0-9.09-7.972,8.025,8.025,0,0,0-13.99,0,8.085,8.085,0,0,0-9.09,7.972,8,8,0,0,0,.07,1.048,8.025,8.025,0,0,0,0,13.99,8,8,0,0,0-.07,1.048,8.091,8.091,0,0,0,9.09,7.972,8.025,8.025,0,0,0,13.99,0,8.1,8.1,0,0,0,9.09-7.972,8,8,0,0,0-.07-1.048,8.025,8.025,0,0,0,0-13.99ZM40.005,50.986l-7.373-7.468L35.5,40.7l4.538,4.6,8.7-8.634,2.831,2.855Z",
    transform: "translate(-21 -21)",
    fill: "none",
    stroke: "#00fe98",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.78d9f1812b843223459c959e44643c89.svg";
export { ForwardRef as ReactComponent };